import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

const Image = styled.img`
  max-width: 100%;
  height: 100%;
  object-fit: cover;
`

const getThumbnailUrls = (videoUrl: string): string[] => {
  const videoUrlWithoutSuffix = videoUrl.split('.').slice(0, -1).join('.')
  const thumbnailSuffixes = ['0', '1', '2']
  return thumbnailSuffixes.map(suffix => `${videoUrlWithoutSuffix}_${suffix}.jpg`)
}

export const VideoThumbnail = ({ videoUrl, showPreview }: { videoUrl: string, showPreview: boolean }): JSX.Element => {
  const [currentThumbnailIndex, setCurrentThumbnailIndex] = useState(0)

  const thumbnailUrls = useMemo(() =>
    getThumbnailUrls(videoUrl), [videoUrl]
  )

  useEffect(function manageCurrentThumbnailIndex () {
    let intervalId: number

    if (showPreview) {
      intervalId = window.setInterval(function increaseThumbnailIndex () {
        setCurrentThumbnailIndex(prev => (prev + 1) % thumbnailUrls.length)
      }, 400)
    }

    return () => {
      clearInterval(intervalId)
      setCurrentThumbnailIndex(0)
    }
  }, [showPreview, thumbnailUrls.length])

  return <Image src={thumbnailUrls[currentThumbnailIndex]} />
}
